<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    class="dialog-over-components"
    @keydown.esc="dialog = false"
  >
    <v-card>
      <card-title
        large
        closeable
        class="flex-grow-0"
        @click:close="dialog = false"
      >
        История изменений
      </card-title>

      <card-content style="position: relative">
        <v-data-table
          v-resize="onResize"
          :height="height(165)"
          :loading="loading"
          :headers="headers"
          :items="items"
          fixed-header
          class="v-datatable-stripped"
          disable-pagination
          disable-filtering
          hide-default-footer
          :footer-props="{
            disableItemsPerPage: true,
            disablePagination: true
          }"
        >
          <template #item="{ item }">
            <tr>
              <td class="text-no-wrap">{{ formatDate(item.dt) }}</td>
              <td class="text-no-wrap">{{ item.user_name }}</td>
              <td>
                <div class="d-flex align-center justify-space-between">
                  <div>{{ getFieldName(item.field_name) }}</div>
                  <div
                    v-if="item.lang_code"
                    class="hist-lang-icon ml-2"
                    :style="
                      `background-image: url(${baseUrl}img/lang-${item.lang_code}.svg);`
                    "
                  />
                </div>
              </td>
              <td v-if="isHtmlItem(item)" colspan="2">
                <div v-html="calcDiff(item)" />
              </td>
              <td v-if="!isHtmlItem(item)">
                <div v-html="prettify(item.value_original)" />
              </td>
              <td v-if="!isHtmlItem(item)">
                <div v-html="prettify(item.value_modified)" />
              </td>
            </tr>
          </template>
        </v-data-table>
      </card-content>
      <card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="confirm-btn-cancel"
          color="primary"
          depressed
          outlined
          @click.native="dialog = false"
        >
          Закрыть
        </v-btn>
      </card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import ResizeMixin from "@/mixins/ResizeMixin";
import Repository from "@/api/history";
import { diffChars } from "diff";
import Const from "@/utils/Const.js";
import moment from "moment";

export default {
  mixins: [NotificationMixin, ResizeMixin],
  model: {
    prop: "open",
    event: "changeDialog"
  },
  props: {
    /**
     * v-model параметр.
     * Используется в dialog
     */
    open: {
      type: Boolean,
      default: false
    },
    /**
     * ID записи по которой нужна детализация истории
     */
    itemObjectId: {
      type: [Number, String],
      default: null
    },
    scopeName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("changeDialog", value);
      }
    },
    headers() {
      return [
        { text: "Дата", value: "dt" },
        { text: "Пользователь", value: "user_name" },
        { text: "Параметр", value: "field_name" },
        { text: "Старое значение", value: "value_original", sortable: false },
        { text: "Новое значение", value: "value_modified", sortable: false }
      ];
    },
    formatDate() {
      return date => (date ? moment(date).format("DD.MM.yyyy HH:mm") : "");
    }
  },
  watch: {
    open(newV) {
      if (newV) {
        this.loadDetails();
      } else {
        this.resetForm();
        this.$emit("close");
      }
    }
  },
  methods: {
    async loadDetails() {
      try {
        const { itemObjectId, scopeName } = this;
        this.loading = true;
        const { data } = await Repository.getObjectDetails(
          scopeName,
          itemObjectId
        );
        this.items = data.items;
      } catch (error) {
        this.sendError(error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.dialog = false;
      this.items = [];
    },
    isHtml(val) {
      return /<\/?[a-z][\s\S]*>/i.test(val);
    },
    isHtmlItem(item) {
      return (
        this.isHtml(item.value_original) || this.isHtml(item.value_modified)
      );
    },
    stripHtml(html) {
      return html
        .replace(/(<([^>]+)>)/gi, " ")
        .replace(/&#?[a-z0-9]{2,8};/gi, " ");
    },
    calcDiff(item) {
      const valueOriginal = this.stripHtml(item.value_original);
      const valueModified = this.stripHtml(item.value_modified);

      const diff = diffChars(valueOriginal, valueModified);

      let res = "";
      diff.forEach(part => {
        const removedColor = part.removed
          ? "red--text font-weight-bold text-decoration-line-through"
          : "";
        const spanClass = part.added
          ? "green white--text font-weight-bold"
          : removedColor;
        if (spanClass.length > 0) {
          res = res + `<span class="${spanClass}">` + part.value + "</span>";
        } else {
          res = res + part.value;
        }
      });

      return res;
    },

    getFieldName(field) {
      return Const.PageFields[this.scopeName]?.[field] || field;
    },

    prettify(val) {
      try {
        const r = JSON.parse(val);
        if (r.items) {
          return r.items.map(item => item.i_main).join("<br />");
        }
        return JSON.stringify(r);
      } catch (e) {
        return this.isHtml(val) ? this.stripHtml(val) : val;
      }
    }
  }
};
</script>
<style lang="scss">
.hist-lang-icon {
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  background-size: 22px;
  border-radius: 24px;
  background-position: center;
  border: 2px solid #d8e0e6;
}
</style>
